import styled from '@emotion/styled';

import theme from '@app/styles/theme';
import { mobile } from '@app/styles/theme/breakpoints';
import { rem } from '@app/styles/theme/layout';

export const Label = styled.label`
  font-weight: 500;
  font-size: ${rem(18)};
`;

export const Wrapper = styled.div`
  width: ${rem(376)};
  position: absolute;
  z-index: ${theme.zIndices.headerPopover};
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.productBorderColor};
  border-right: 0;
  top: ${rem(60)};
  right: 0;
  display: flex;
  flex-direction: column;
  padding: ${rem(15)} ${rem(25)};

  @media (max-width: ${mobile}) {
    width: 100%;
  }
`;
